import { IonButton } from "@ionic/react";
import { useHistory } from "react-router";

interface Props {
  setSystemError: Function;
}
const SystemErrorModal: React.FC<Props> = ({ setSystemError }) => {
  let history = useHistory();

  const end_task = () => {
    setSystemError(false);
    history.push("/patient-page");
  };

  return (
    <>
      <div className="system-error-modal">
        {/* <div className="d-flex justify-content-end">
          <svg
            onClick={() => {
              setSystemError(false);
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div> */}
        <div className="text-center flex-column">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="126"
            height="127"
            viewBox="0 0 126 127"
            fill="none"
          >
            <path
              d="M56.4095 85.16C56.4095 81.6929 59.2202 78.8822 62.6873 78.8822H63.3151C66.7822 78.8822 69.5929 81.6929 69.5929 85.16V85.7878C69.5929 89.2549 66.7822 92.0656 63.3151 92.0656H62.6873C59.2202 92.0656 56.4095 89.2549 56.4095 85.7878V85.16Z"
              fill="#890029"
            />
            <path
              d="M69.2777 41.2156C69.2777 37.7484 66.4671 34.9378 63 34.9378C59.5328 34.9378 56.7222 37.7484 56.7222 41.2156V66.3267C56.7222 69.7938 59.5328 72.6045 63 72.6045C66.4671 72.6045 69.2777 69.7938 69.2777 66.3267V41.2156Z"
              fill="#890029"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.2982 4.40009C35.6528 2.04547 38.8464 0.722656 42.1763 0.722656H83.8236C87.1535 0.722656 90.3471 2.04547 92.7017 4.4001L122.1 33.7987C124.455 36.1533 125.778 39.3469 125.778 42.6768V84.3241C125.778 87.654 124.455 90.8476 122.1 93.2022L92.7017 122.601C90.3471 124.955 87.1535 126.278 83.8236 126.278H42.1763C38.8464 126.278 35.6528 124.955 33.2982 122.601L3.8996 93.2022C1.54498 90.8475 0.222168 87.654 0.222168 84.324V42.6768C0.222168 39.3469 1.54498 36.1533 3.8996 33.7987L33.2982 4.40009ZM83.8236 13.2782L42.1763 13.2782L12.7777 42.6768L12.7777 84.324L42.1763 113.723L83.8236 113.723L113.222 84.3241V42.6768L83.8236 13.2782Z"
              fill="#890029"
            />
          </svg>
          <h1 className="assesment-modal-label mb-0">System Error</h1>
          <p className="assesment-modal-desc">
            We have encountered a problem. <br></br> Please close and restart
            the application.
          </p>
        </div>
        <IonButton
          placeholder={undefined}
          className="blue-btn"
          onClick={() => {
            end_task();
          }}
        >
          Close App
        </IonButton>
      </div>
    </>
  );
};
export default SystemErrorModal;
